import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Login from "@/views/Login.vue";
import AccessDenied from "@/views/AccessDenied.vue";
import AuthCallback from "@/views/AuthCallback.vue";
import SignedOut from "@/views/SignedOut.vue";
import NotFound from "@/views/NotFound.vue";

import { Hub } from "aws-amplify";

const Main = () => import("@/views/Main.vue");
const Home = () => import("@/views/Home.vue");
const PMSConnectorList = () => import("@/views/PMSConnectors.vue");
const PMSConnector = () => import('@/views/pmsConnector/Index.vue')

const pmsConnectorGroups = ["HubSuperAdmins", "HubConsoleAdmins", "HubConsoleUsers", "HubConsoleViewers"];
const pmsConnectorAdminGroups =  ["HubSuperAdmins", "HubConsoleAdmins"];

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { allowUnauthenticated: true },
  },
  {
    path: "/callback",
    name: "callback",
    component: AuthCallback,
    meta: { allowUnauthenticated: true },
  },
  {
    path: "/accessDenied",
    name: "AccessDenied",
    component: AccessDenied,
    meta: { allowUnauthenticated: true },
  },
  {
    path: "/signedOut",
    name: "SignedOut",
    component: SignedOut,
    meta: { allowUnauthenticated: true },
  },
  {
    path: "/",
    name: "",
    component: Main,
    meta: {
      authorizedGroups: pmsConnectorGroups,
    },
    children: [
      {
        path: "/",
        name: "Home",
        component: Home,
        meta: {
          authorizedGroups: pmsConnectorGroups,
        },
      },
      {

        path: "/pmsConnectors",
        name: "PmsConnectorList",
        component: PMSConnectorList,
        meta: {
          authorizedGroups: pmsConnectorGroups,
        }
      },
      {
        path: "/pmsConnector/:sub",
        name: "",
        component: PMSConnector,
        meta: {
          authorizedGroups: pmsConnectorGroups
        },
        children: [ 
          {
            path: "", 
            name: "PmsConnector",
            component: () => import('@/views/pmsConnector/Details.vue'),
            meta: {
              authorizedGroups: pmsConnectorGroups
            }
          },
          {
            path: "/pmsConnector/:sub/products",
            name: "",
            component: () => import("@/views/pmsConnector/products/ProductShell.vue"),
            meta: {
              authorizedGroups: pmsConnectorGroups
            },
            children: [
              {
                path: "",
                name: "PmsConnProducts",
                component: () => import("@/views/pmsConnector/products/ProductIndex.vue"),
                meta: {
                  authorizedGroups: pmsConnectorGroups
                }
              },
              {
                path: "/pmsConnector/:sub/products/add",
                name: "PmsConnProductAdd",
                component: () => import("@/views/pmsConnector/products/ProductAdd.vue"),
                meta: {
                  authorizedGroups: pmsConnectorGroups
                }
              },
              {
                path: "/pmsConnector/:sub/products/add/mh1",
                name: "AddMh1",
                component: () => import("@/views/pmsConnector/products/AddMh1.vue"),
                meta: {
                  authorizedGroups: pmsConnectorGroups
                }
              },
              {
                path: "/pmsConnector/:sub/products/manage/mh1/:mh1PracticeId",
                name: "ManageMh1",
                component: () => import("@/views/pmsConnector/products/ManageMh1.vue"),
                meta: {
                  authorizedGroups: pmsConnectorGroups
                }
              }

            ]
          },
          {
            path: "/pmsConnector/:sub/heartbeats",
            name: "Heartbeats",
            component: () => import('@/views/pmsConnector/Heartbeats.vue'),
            meta: {
              authorizedGroups: pmsConnectorGroups
            },
          },
          {
            path: "/pmsConnector/:sub/logs",
            name: "Logs",
            component: () => import('@/views/pmsConnector/Logs.vue'),
            meta: {
              authorizedGroups: pmsConnectorGroups
            },
          },
          {
            path: "/pmsConnector/:sub/remoteControl",
            name: "RemoteControl",
            component: () => import('@/views/pmsConnector/RemoteControl.vue'),
            meta: {
              authorizedGroups: pmsConnectorGroups
            },
          },
          {
            path: "/pmsConnector/:sub/setup",
            name: "Setup",
            component: () => import('@/views/pmsConnector/Setup.vue'),
            meta: {
              authorizedGroups: pmsConnectorAdminGroups
            },
          },
          {
            path: "/pmsConnector/:sub/availability",
            name: "",
            component: () => import('@/views/pmsConnector/Availability.vue'),
            meta: {
              authorizedGroups: pmsConnectorGroups
            },
            children: [
              {
                path: "/pmsConnector/:sub/availability",
                name: "AvailabilityList",
                component: () => import('@/views/pmsConnector/AvailabilityList.vue'),
                meta: {
                  authorizedGroups: pmsConnectorGroups
                }
              },
              {
                path: "/pmsConnector/:sub/availabilityDetails/:key",
                name: "AvailabilityDetails",
                component: () => import('@/views/pmsConnector/AvailabilityDetails.vue'),
                meta: {
                  authorizedGroups: pmsConnectorGroups
                },
              }
            ]
          },

          {
            path: "/pmsConnector/:sub/pmsInfo",
            name: "PMSInfo",
            component: () => import('@/views/pmsConnector/PmsInfo.vue'),
            meta: {
              authorizedGroups: pmsConnectorGroups
            },
          }

        ]
      }
    ],
  },
  {
    path: "*",
    name: "NotFound",
    component: NotFound,
    meta: { allowUnauthenticated: true },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// https://docs.amplify.aws/lib/auth/social/q/platform/js#full-samples
Hub.listen("auth", ({ payload: { event, data } }) => {
  switch (event) {
    case "signIn":
      //AmplifyStore.commit('user', data);
      //this.setState({ user: data });
      break;
    case "signOut":
      //AmplifyStore.commit('user', data);
      //this.setState({ user: null });

      break;
  }
});

async function getUser() {
  try {
    const user = await Vue.prototype.$Amplify.Auth.currentAuthenticatedUser();
    if (user?.signInUserSession) {
      return user;
    } else {
      console.log("router.getUser invalid user data", user);
      return null;
    }
  } catch (err) {
    console.log("router.getUser err", err);
    return null;
  }
}

router.beforeEach(async (to, from, next) => {

  if (to.matched.every((record) => record.meta?.allowUnauthenticated)) {
    console.log("Allowing unathenticated route ", to, from);
    next();
    return;
  }

  const user = await getUser();

  if (!user) {
    console.log("Not logged in, redirect to Login ", to, from);

    next({
      path: "/login",
      query: { redirect: to.fullPath },
    });
    return;
  }

  //const authorizedGroupsForRoute = to.matched.flatMap(
  //  (record) => record.meta?.authorizedGroups ?? []
  //);

  const authorizedGroupsForRoute: string[] = to.meta?.authorizedGroups ?? [];

  // At least one group needs to be defined in the path's authorized groups list
  const routeHasGroups =
    authorizedGroupsForRoute && authorizedGroupsForRoute?.length > 0;

  if (!routeHasGroups) {
    console.log(
      "Disallowing navigation, no auth groups set for route",
      to,
      from
    );

    next({
      path: "/accessDenied",
      query: { redirect: to.fullPath },
    });
    return;
  }

  const thisUsersGroups: string[] =
    user?.signInUserSession?.accessToken?.payload["cognito:groups"] ?? [];

  /*
const hasAccess = authorizedGroupsForRoute.every(
  (requiredGroup) => thisUsersGroups.indexOf(requiredGroup) >= 0
);*/

  const hasAccess = authorizedGroupsForRoute.some(ag => thisUsersGroups.indexOf(ag) >= 0);

  if (!hasAccess) {
    console.log(
      "Blocking navigation, user not assigned requried groups for route. ",
      authorizedGroupsForRoute,
      thisUsersGroups, to, from

    );

    next({
      path: "/accessDenied",
      query: { redirect: to.fullPath },
    });
    return;
  }

  console.log(
    "User has access, allowing nav. ",
    authorizedGroupsForRoute,
    thisUsersGroups
  );
  next();
});

export default router;
